import { ReactNode, useCallback, useState } from "react";
import { MobileMenuContext, NavbarEntry, rootNavbarEntry } from "./mobile-menu-context";

export function MobileMenuContextProvider({ children, close }: { children: ReactNode; close(): void }) {
  const [allPages, setAllPages] = useState(new Map<string, NavbarEntry>());
  const [currentPage, setCurrentPage] = useState(rootNavbarEntry);

  const up = useCallback(() => {
    setCurrentPage((current) => {
      if (!current.parent) return current;

      return current.parent;
    });
  }, [currentPage]);

  return (
    <MobileMenuContext.Provider
      value={{
        close,
        allPages,
        setAllPages,
        currentPage,
        setCurrentPage,
        up,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  );
}
